import React from "react";
import { Route, Routes } from "react-router-dom";
import Business from "./Business/Business";
import Buy from "./Buy/Buy";
import Dashboard from "./profile/Dashboard";
import MediaLibrary from "./Media/MediaLibrary";
import Addaccount from "./posting/Addaccount";
import CreateFeed from "./posting/CreateFeed";
import Feed from "./posting/Feed";
import Myfeed from "./posting/Myfeed";
import Post from "./posting/Post";
import Posting from "./posting/Posting";
import Payment from "./Wallet/Payment";
import Wallet from "./Wallet/Wallet";
import Profile from "./profile/Profile";
import Setting from "./setting/Setting";
import Analytics from "./Analytics/Analytics";
import Verification from "./Info/Verification";
import Preview from "./Info/Preview";
import Code from "./Info/Code";
import Binfo from "./Info/Binfo";
import Address from "./Info/Address";
import Detail from "./Info/Detail";
import Video from "./Info/Video";
import Monitor from "./monitorMedia/Monitor";
import Adds from "./Banner/Adds";
import Listing from "./Listing/Listing";
import Schedule from "./Schdule/Schedule";
import MonitorRestricted from "./monitorMedia/MonitorRestricted";
import AddWebsite from "./AddWebsite/AddWebsite";
import Signin from "./Signin/Signin";
import CreatePost from "./posting/CreatePost";
import BuyAndSell from "./Buy/BuyAndSell";
import { ViewList } from "@mui/icons-material";
import ViewListing from "./Listing/ViewListing";
import ViewPost from "./posting/ViewPost";
import ListingUpdate from "./Listing/ListingUpate";
import PostingUpdate from "./posting/PostingUpdate";
import BuySell from "./Listing/BuySell";

function Home() {
  return (
    <Routes>
    <Route path="/" element={<Signin />} />
      <Route path="/bioInfo" element={<Binfo />} />
      <Route path="/address" element={<Address />} />
      <Route path="/detail" element={<Detail />} />
      <Route path="/video" element={<Preview />} />
      <Route path="/preview" element={<Preview />} />
      <Route path="/view/listing/:id" element={<ViewListing/>} />
      <Route path="/view/posting/:id" element={<ViewPost/>} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/listing/update/:id" element={<ListingUpdate />} />
      <Route path="/posting/update/:id" element={<PostingUpdate />} />
      <Route path="/post" element={<Posting />} />
      <Route path="/buy" element={<Buy />} />
      <Route path="/business" element={<Business />} />
      <Route path="/feed" element={<CreateFeed />} />
      <Route path="/create/posting/:id" element={<CreatePost />} />
      <Route path="/add" element={<Addaccount />} />
      <Route path="/myfeed" element={<Feed />} />
      <Route path="/media" element={<MediaLibrary />} />
      <Route path="/feeds" element={<Myfeed />} />
      <Route path="/wallet" element={<Wallet />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/setting" element={<Setting />} />
      <Route path="/analytics" element={<Analytics />} />
      <Route path="/buy&sell" element={<BuySell/>}/>
      <Route path="/verify" element={<Verification />} />
      <Route path="/code" element={<Code />} />
      <Route path="/monitor" element={<Monitor />} />
      <Route path="/adds" element={<Adds />} />
      <Route path="/listing" element={<Listing />} />
      <Route path="/schedule" element={<Schedule />} />
      <Route path="/restricted" element={<MonitorRestricted />} />
      {/* <Route path="/add-website" element={<AddWebsite />} /> */}
      <Route path="/signin" element={<Signin />} />
    </Routes>
  );
}

export default Home;
